import { render, staticRenderFns } from "./InstallmentsInfo.vue?vue&type=template&id=cd06870a&scoped=true&"
import script from "./InstallmentsInfo.vue?vue&type=script&lang=js&"
export * from "./InstallmentsInfo.vue?vue&type=script&lang=js&"
import style0 from "./InstallmentsInfo.vue?vue&type=style&index=0&id=cd06870a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd06870a",
  null
  
)

export default component.exports